export default {
  "content": "<path fill=\"none\" d=\"M0 0h16v16H0z\" data-name=\"Bounding box\"/><path d=\"M14.065 2H10V1a1 1 0 00-1-1H7a1 1 0 00-1 1v1H1.935A.935.935 0 001 2.935v1.13A.935.935 0 001.935 5H2v10a1 1 0 001 1h10a1 1 0 001-1V5h.065A.935.935 0 0015 4.065v-1.13A.935.935 0 0014.065 2zM7 13a1 1 0 01-2 0V7a1 1 0 012 0zm4 0a1 1 0 01-2 0V7a1 1 0 012 0z\" fill=\"#3f4450\" data-name=\"Layer 1\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "viewBox": "0 0 16 16"
  }
};